<template lang="pug">
    div
        AppNav
        div.col-1
        div.col-8
          h4 Créer un nouvel utilisateur
          br
          form(role='form',style='max-width: 300px;', autocomplete="nope")
              .form-group
                  input.form-control(type='text',autocomplete="nope", name="email", placeholder='Entrer votre email' autofocus required v-model.trim="email")
              .form-group
                  select.form-control( v-model="role")
                      option( value="" selected data-default) Choisir le type d'utilisateur
                      option user
                      option admin
              .form-group
                  input.form-control(type='password', name="password", placeholder='Password' required v-model.trim="password")
              button.btn.btn-default( @click.prevent="register") Valider
              a(href='/')
                  button.btn.btn-primary(type="button") Annuler
        h4= info
</template>
<script>
import AppNav from './AppNav'
import {
  USER_REGISTER,
  ALL_USERS
} from '../constants/user'
export default {
  name: 'register',
  components: {
    AppNav
  },
  data () {
    return {
      email: '',
      password: '',
      role: ''
    }
  },
  methods:{
    register(){
      const email = this.email
      const secret = this.password
      const role = this.role
      this.$apollo.mutate({
        mutation: USER_REGISTER,
        variables: {
          email: this.email,
          password: this.password,
          role: this.role
        },
        refetchQueries: [{
          query: ALL_USERS
        }]
      }).then((data) => {
        this.email= ''
        this.password = ''
        this.$router.push({name: 'Users'})
      }).catch((error) => {
        // Error
        console.error(error);
        // We restore the initial user input
        this.email = email
      })
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// register.vue?13eeb439